/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type CreateCurrenciesInput = {
  id?: string | null,
  CurrencyCode?: string | null,
  CurrencyName?: string | null,
  _version?: number | null,
};

export type ModelCurrenciesConditionInput = {
  CurrencyCode?: ModelStringInput | null,
  CurrencyName?: ModelStringInput | null,
  and?: Array< ModelCurrenciesConditionInput | null > | null,
  or?: Array< ModelCurrenciesConditionInput | null > | null,
  not?: ModelCurrenciesConditionInput | null,
};

export type ModelStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export enum ModelAttributeTypes {
  binary = "binary",
  binarySet = "binarySet",
  bool = "bool",
  list = "list",
  map = "map",
  number = "number",
  numberSet = "numberSet",
  string = "string",
  stringSet = "stringSet",
  _null = "_null",
}


export type ModelSizeInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
};

export type Currencies = {
  __typename: "Currencies",
  id: string,
  CurrencyCode?: string | null,
  CurrencyName?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateCurrenciesInput = {
  id: string,
  CurrencyCode?: string | null,
  CurrencyName?: string | null,
  _version?: number | null,
};

export type DeleteCurrenciesInput = {
  id: string,
  _version?: number | null,
};

export type CreateAppConfigInput = {
  id?: string | null,
  appName?: AppNames | null,
  enableFreezeCard?: FeatureFlagTypeInput | null,
  enableShowPin?: boolean | null,
  minimumTmcTopUpAmount?: number | null,
  _version?: number | null,
};

export enum AppNames {
  TRAVEL = "TRAVEL",
}


export type FeatureFlagTypeInput = {
  isEnabled?: boolean | null,
  description?: string | null,
};

export type ModelAppConfigConditionInput = {
  appName?: ModelAppNamesInput | null,
  enableShowPin?: ModelBooleanInput | null,
  minimumTmcTopUpAmount?: ModelIntInput | null,
  and?: Array< ModelAppConfigConditionInput | null > | null,
  or?: Array< ModelAppConfigConditionInput | null > | null,
  not?: ModelAppConfigConditionInput | null,
};

export type ModelAppNamesInput = {
  eq?: AppNames | null,
  ne?: AppNames | null,
};

export type ModelBooleanInput = {
  ne?: boolean | null,
  eq?: boolean | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type ModelIntInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type AppConfig = {
  __typename: "AppConfig",
  id: string,
  appName?: AppNames | null,
  enableFreezeCard?: FeatureFlagType | null,
  enableShowPin?: boolean | null,
  minimumTmcTopUpAmount?: number | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type FeatureFlagType = {
  __typename: "FeatureFlagType",
  isEnabled?: boolean | null,
  description?: string | null,
};

export type UpdateAppConfigInput = {
  id: string,
  appName?: AppNames | null,
  enableFreezeCard?: FeatureFlagTypeInput | null,
  enableShowPin?: boolean | null,
  minimumTmcTopUpAmount?: number | null,
  _version?: number | null,
};

export type DeleteAppConfigInput = {
  id: string,
  _version?: number | null,
};

export type CreateFeatureFlagInput = {
  id?: string | null,
  name?: string | null,
  description?: string | null,
  enabled?: boolean | null,
  _version?: number | null,
};

export type ModelFeatureFlagConditionInput = {
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  enabled?: ModelBooleanInput | null,
  and?: Array< ModelFeatureFlagConditionInput | null > | null,
  or?: Array< ModelFeatureFlagConditionInput | null > | null,
  not?: ModelFeatureFlagConditionInput | null,
};

export type FeatureFlag = {
  __typename: "FeatureFlag",
  id: string,
  name?: string | null,
  description?: string | null,
  enabled?: boolean | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateFeatureFlagInput = {
  id: string,
  name?: string | null,
  description?: string | null,
  enabled?: boolean | null,
  _version?: number | null,
};

export type DeleteFeatureFlagInput = {
  id: string,
  _version?: number | null,
};

export type CreateErrorMessagesInput = {
  id?: string | null,
  ErrorKey?: ErrorKeys | null,
  ErrorNumber?: number | null,
  ErrorDescription?: string | null,
  InAppErrorMessage?: InAppErrorMessageTypeInput | null,
  _version?: number | null,
};

export enum ErrorKeys {
  TMC_Topup = "TMC_Topup",
  Authentication = "Authentication",
  TMC_ACTIVATECARDLINKSUCCESS = "TMC_ACTIVATECARDLINKSUCCESS",
  ONB_REGISTRATIONSECONDSTEP = "ONB_REGISTRATIONSECONDSTEP",
  PASSCODE_REGISTER = "PASSCODE_REGISTER",
  TMC_CARDOVERVIEW = "TMC_CARDOVERVIEW",
  PASSCODE_UNLOCK = "PASSCODE_UNLOCK",
  LOGIN_INPUTEMAIL = "LOGIN_INPUTEMAIL",
  TMC_TOPUPCONFIRM = "TMC_TOPUPCONFIRM",
  TEST = "TEST",
  NETWORK = "NETWORK",
}


export type InAppErrorMessageTypeInput = {
  title?: string | null,
  body?: string | null,
};

export type ModelErrorMessagesConditionInput = {
  ErrorKey?: ModelErrorKeysInput | null,
  ErrorNumber?: ModelIntInput | null,
  ErrorDescription?: ModelStringInput | null,
  and?: Array< ModelErrorMessagesConditionInput | null > | null,
  or?: Array< ModelErrorMessagesConditionInput | null > | null,
  not?: ModelErrorMessagesConditionInput | null,
};

export type ModelErrorKeysInput = {
  eq?: ErrorKeys | null,
  ne?: ErrorKeys | null,
};

export type ErrorMessages = {
  __typename: "ErrorMessages",
  id: string,
  ErrorKey?: ErrorKeys | null,
  ErrorNumber?: number | null,
  ErrorDescription?: string | null,
  InAppErrorMessage?: InAppErrorMessageType | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type InAppErrorMessageType = {
  __typename: "InAppErrorMessageType",
  title?: string | null,
  body?: string | null,
};

export type UpdateErrorMessagesInput = {
  id: string,
  ErrorKey?: ErrorKeys | null,
  ErrorNumber?: number | null,
  ErrorDescription?: string | null,
  InAppErrorMessage?: InAppErrorMessageTypeInput | null,
  _version?: number | null,
};

export type DeleteErrorMessagesInput = {
  id: string,
  _version?: number | null,
};

export type ModelCurrenciesFilterInput = {
  id?: ModelIDInput | null,
  CurrencyCode?: ModelStringInput | null,
  CurrencyName?: ModelStringInput | null,
  and?: Array< ModelCurrenciesFilterInput | null > | null,
  or?: Array< ModelCurrenciesFilterInput | null > | null,
  not?: ModelCurrenciesFilterInput | null,
};

export type ModelIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export type ModelCurrenciesConnection = {
  __typename: "ModelCurrenciesConnection",
  items:  Array<Currencies | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelAppConfigFilterInput = {
  id?: ModelIDInput | null,
  appName?: ModelAppNamesInput | null,
  enableShowPin?: ModelBooleanInput | null,
  minimumTmcTopUpAmount?: ModelIntInput | null,
  and?: Array< ModelAppConfigFilterInput | null > | null,
  or?: Array< ModelAppConfigFilterInput | null > | null,
  not?: ModelAppConfigFilterInput | null,
};

export type ModelAppConfigConnection = {
  __typename: "ModelAppConfigConnection",
  items:  Array<AppConfig | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelFeatureFlagFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  enabled?: ModelBooleanInput | null,
  and?: Array< ModelFeatureFlagFilterInput | null > | null,
  or?: Array< ModelFeatureFlagFilterInput | null > | null,
  not?: ModelFeatureFlagFilterInput | null,
};

export type ModelFeatureFlagConnection = {
  __typename: "ModelFeatureFlagConnection",
  items:  Array<FeatureFlag | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelErrorMessagesFilterInput = {
  id?: ModelIDInput | null,
  ErrorKey?: ModelErrorKeysInput | null,
  ErrorNumber?: ModelIntInput | null,
  ErrorDescription?: ModelStringInput | null,
  and?: Array< ModelErrorMessagesFilterInput | null > | null,
  or?: Array< ModelErrorMessagesFilterInput | null > | null,
  not?: ModelErrorMessagesFilterInput | null,
};

export type ModelErrorMessagesConnection = {
  __typename: "ModelErrorMessagesConnection",
  items:  Array<ErrorMessages | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelSubscriptionCurrenciesFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  CurrencyCode?: ModelSubscriptionStringInput | null,
  CurrencyName?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionCurrenciesFilterInput | null > | null,
  or?: Array< ModelSubscriptionCurrenciesFilterInput | null > | null,
};

export type ModelSubscriptionIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  in?: Array< string | null > | null,
  notIn?: Array< string | null > | null,
};

export type ModelSubscriptionStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  in?: Array< string | null > | null,
  notIn?: Array< string | null > | null,
};

export type ModelSubscriptionAppConfigFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  appName?: ModelSubscriptionStringInput | null,
  enableShowPin?: ModelSubscriptionBooleanInput | null,
  minimumTmcTopUpAmount?: ModelSubscriptionIntInput | null,
  and?: Array< ModelSubscriptionAppConfigFilterInput | null > | null,
  or?: Array< ModelSubscriptionAppConfigFilterInput | null > | null,
};

export type ModelSubscriptionBooleanInput = {
  ne?: boolean | null,
  eq?: boolean | null,
};

export type ModelSubscriptionIntInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  in?: Array< number | null > | null,
  notIn?: Array< number | null > | null,
};

export type ModelSubscriptionFeatureFlagFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  enabled?: ModelSubscriptionBooleanInput | null,
  and?: Array< ModelSubscriptionFeatureFlagFilterInput | null > | null,
  or?: Array< ModelSubscriptionFeatureFlagFilterInput | null > | null,
};

export type ModelSubscriptionErrorMessagesFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  ErrorKey?: ModelSubscriptionStringInput | null,
  ErrorNumber?: ModelSubscriptionIntInput | null,
  ErrorDescription?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionErrorMessagesFilterInput | null > | null,
  or?: Array< ModelSubscriptionErrorMessagesFilterInput | null > | null,
};

export type CreateCurrenciesMutationVariables = {
  input: CreateCurrenciesInput,
  condition?: ModelCurrenciesConditionInput | null,
};

export type CreateCurrenciesMutation = {
  createCurrencies?:  {
    __typename: "Currencies",
    id: string,
    CurrencyCode?: string | null,
    CurrencyName?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateCurrenciesMutationVariables = {
  input: UpdateCurrenciesInput,
  condition?: ModelCurrenciesConditionInput | null,
};

export type UpdateCurrenciesMutation = {
  updateCurrencies?:  {
    __typename: "Currencies",
    id: string,
    CurrencyCode?: string | null,
    CurrencyName?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteCurrenciesMutationVariables = {
  input: DeleteCurrenciesInput,
  condition?: ModelCurrenciesConditionInput | null,
};

export type DeleteCurrenciesMutation = {
  deleteCurrencies?:  {
    __typename: "Currencies",
    id: string,
    CurrencyCode?: string | null,
    CurrencyName?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateAppConfigMutationVariables = {
  input: CreateAppConfigInput,
  condition?: ModelAppConfigConditionInput | null,
};

export type CreateAppConfigMutation = {
  createAppConfig?:  {
    __typename: "AppConfig",
    id: string,
    appName?: AppNames | null,
    enableFreezeCard?:  {
      __typename: "FeatureFlagType",
      isEnabled?: boolean | null,
      description?: string | null,
    } | null,
    enableShowPin?: boolean | null,
    minimumTmcTopUpAmount?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateAppConfigMutationVariables = {
  input: UpdateAppConfigInput,
  condition?: ModelAppConfigConditionInput | null,
};

export type UpdateAppConfigMutation = {
  updateAppConfig?:  {
    __typename: "AppConfig",
    id: string,
    appName?: AppNames | null,
    enableFreezeCard?:  {
      __typename: "FeatureFlagType",
      isEnabled?: boolean | null,
      description?: string | null,
    } | null,
    enableShowPin?: boolean | null,
    minimumTmcTopUpAmount?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteAppConfigMutationVariables = {
  input: DeleteAppConfigInput,
  condition?: ModelAppConfigConditionInput | null,
};

export type DeleteAppConfigMutation = {
  deleteAppConfig?:  {
    __typename: "AppConfig",
    id: string,
    appName?: AppNames | null,
    enableFreezeCard?:  {
      __typename: "FeatureFlagType",
      isEnabled?: boolean | null,
      description?: string | null,
    } | null,
    enableShowPin?: boolean | null,
    minimumTmcTopUpAmount?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateFeatureFlagMutationVariables = {
  input: CreateFeatureFlagInput,
  condition?: ModelFeatureFlagConditionInput | null,
};

export type CreateFeatureFlagMutation = {
  createFeatureFlag?:  {
    __typename: "FeatureFlag",
    id: string,
    name?: string | null,
    description?: string | null,
    enabled?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateFeatureFlagMutationVariables = {
  input: UpdateFeatureFlagInput,
  condition?: ModelFeatureFlagConditionInput | null,
};

export type UpdateFeatureFlagMutation = {
  updateFeatureFlag?:  {
    __typename: "FeatureFlag",
    id: string,
    name?: string | null,
    description?: string | null,
    enabled?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteFeatureFlagMutationVariables = {
  input: DeleteFeatureFlagInput,
  condition?: ModelFeatureFlagConditionInput | null,
};

export type DeleteFeatureFlagMutation = {
  deleteFeatureFlag?:  {
    __typename: "FeatureFlag",
    id: string,
    name?: string | null,
    description?: string | null,
    enabled?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateErrorMessagesMutationVariables = {
  input: CreateErrorMessagesInput,
  condition?: ModelErrorMessagesConditionInput | null,
};

export type CreateErrorMessagesMutation = {
  createErrorMessages?:  {
    __typename: "ErrorMessages",
    id: string,
    ErrorKey?: ErrorKeys | null,
    ErrorNumber?: number | null,
    ErrorDescription?: string | null,
    InAppErrorMessage?:  {
      __typename: "InAppErrorMessageType",
      title?: string | null,
      body?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateErrorMessagesMutationVariables = {
  input: UpdateErrorMessagesInput,
  condition?: ModelErrorMessagesConditionInput | null,
};

export type UpdateErrorMessagesMutation = {
  updateErrorMessages?:  {
    __typename: "ErrorMessages",
    id: string,
    ErrorKey?: ErrorKeys | null,
    ErrorNumber?: number | null,
    ErrorDescription?: string | null,
    InAppErrorMessage?:  {
      __typename: "InAppErrorMessageType",
      title?: string | null,
      body?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteErrorMessagesMutationVariables = {
  input: DeleteErrorMessagesInput,
  condition?: ModelErrorMessagesConditionInput | null,
};

export type DeleteErrorMessagesMutation = {
  deleteErrorMessages?:  {
    __typename: "ErrorMessages",
    id: string,
    ErrorKey?: ErrorKeys | null,
    ErrorNumber?: number | null,
    ErrorDescription?: string | null,
    InAppErrorMessage?:  {
      __typename: "InAppErrorMessageType",
      title?: string | null,
      body?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type GetCurrenciesQueryVariables = {
  id: string,
};

export type GetCurrenciesQuery = {
  getCurrencies?:  {
    __typename: "Currencies",
    id: string,
    CurrencyCode?: string | null,
    CurrencyName?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListCurrenciesQueryVariables = {
  filter?: ModelCurrenciesFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCurrenciesQuery = {
  listCurrencies?:  {
    __typename: "ModelCurrenciesConnection",
    items:  Array< {
      __typename: "Currencies",
      id: string,
      CurrencyCode?: string | null,
      CurrencyName?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncCurrenciesQueryVariables = {
  filter?: ModelCurrenciesFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncCurrenciesQuery = {
  syncCurrencies?:  {
    __typename: "ModelCurrenciesConnection",
    items:  Array< {
      __typename: "Currencies",
      id: string,
      CurrencyCode?: string | null,
      CurrencyName?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetAppConfigQueryVariables = {
  id: string,
};

export type GetAppConfigQuery = {
  getAppConfig?:  {
    __typename: "AppConfig",
    id: string,
    appName?: AppNames | null,
    enableFreezeCard?:  {
      __typename: "FeatureFlagType",
      isEnabled?: boolean | null,
      description?: string | null,
    } | null,
    enableShowPin?: boolean | null,
    minimumTmcTopUpAmount?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListAppConfigsQueryVariables = {
  filter?: ModelAppConfigFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAppConfigsQuery = {
  listAppConfigs?:  {
    __typename: "ModelAppConfigConnection",
    items:  Array< {
      __typename: "AppConfig",
      id: string,
      appName?: AppNames | null,
      enableFreezeCard?:  {
        __typename: "FeatureFlagType",
        isEnabled?: boolean | null,
        description?: string | null,
      } | null,
      enableShowPin?: boolean | null,
      minimumTmcTopUpAmount?: number | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncAppConfigsQueryVariables = {
  filter?: ModelAppConfigFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncAppConfigsQuery = {
  syncAppConfigs?:  {
    __typename: "ModelAppConfigConnection",
    items:  Array< {
      __typename: "AppConfig",
      id: string,
      appName?: AppNames | null,
      enableFreezeCard?:  {
        __typename: "FeatureFlagType",
        isEnabled?: boolean | null,
        description?: string | null,
      } | null,
      enableShowPin?: boolean | null,
      minimumTmcTopUpAmount?: number | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetFeatureFlagQueryVariables = {
  id: string,
};

export type GetFeatureFlagQuery = {
  getFeatureFlag?:  {
    __typename: "FeatureFlag",
    id: string,
    name?: string | null,
    description?: string | null,
    enabled?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListFeatureFlagsQueryVariables = {
  filter?: ModelFeatureFlagFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListFeatureFlagsQuery = {
  listFeatureFlags?:  {
    __typename: "ModelFeatureFlagConnection",
    items:  Array< {
      __typename: "FeatureFlag",
      id: string,
      name?: string | null,
      description?: string | null,
      enabled?: boolean | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncFeatureFlagsQueryVariables = {
  filter?: ModelFeatureFlagFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncFeatureFlagsQuery = {
  syncFeatureFlags?:  {
    __typename: "ModelFeatureFlagConnection",
    items:  Array< {
      __typename: "FeatureFlag",
      id: string,
      name?: string | null,
      description?: string | null,
      enabled?: boolean | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetErrorMessagesQueryVariables = {
  id: string,
};

export type GetErrorMessagesQuery = {
  getErrorMessages?:  {
    __typename: "ErrorMessages",
    id: string,
    ErrorKey?: ErrorKeys | null,
    ErrorNumber?: number | null,
    ErrorDescription?: string | null,
    InAppErrorMessage?:  {
      __typename: "InAppErrorMessageType",
      title?: string | null,
      body?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListErrorMessagesQueryVariables = {
  filter?: ModelErrorMessagesFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListErrorMessagesQuery = {
  listErrorMessages?:  {
    __typename: "ModelErrorMessagesConnection",
    items:  Array< {
      __typename: "ErrorMessages",
      id: string,
      ErrorKey?: ErrorKeys | null,
      ErrorNumber?: number | null,
      ErrorDescription?: string | null,
      InAppErrorMessage?:  {
        __typename: "InAppErrorMessageType",
        title?: string | null,
        body?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncErrorMessagesQueryVariables = {
  filter?: ModelErrorMessagesFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncErrorMessagesQuery = {
  syncErrorMessages?:  {
    __typename: "ModelErrorMessagesConnection",
    items:  Array< {
      __typename: "ErrorMessages",
      id: string,
      ErrorKey?: ErrorKeys | null,
      ErrorNumber?: number | null,
      ErrorDescription?: string | null,
      InAppErrorMessage?:  {
        __typename: "InAppErrorMessageType",
        title?: string | null,
        body?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type OnCreateCurrenciesSubscriptionVariables = {
  filter?: ModelSubscriptionCurrenciesFilterInput | null,
};

export type OnCreateCurrenciesSubscription = {
  onCreateCurrencies?:  {
    __typename: "Currencies",
    id: string,
    CurrencyCode?: string | null,
    CurrencyName?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateCurrenciesSubscriptionVariables = {
  filter?: ModelSubscriptionCurrenciesFilterInput | null,
};

export type OnUpdateCurrenciesSubscription = {
  onUpdateCurrencies?:  {
    __typename: "Currencies",
    id: string,
    CurrencyCode?: string | null,
    CurrencyName?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteCurrenciesSubscriptionVariables = {
  filter?: ModelSubscriptionCurrenciesFilterInput | null,
};

export type OnDeleteCurrenciesSubscription = {
  onDeleteCurrencies?:  {
    __typename: "Currencies",
    id: string,
    CurrencyCode?: string | null,
    CurrencyName?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateAppConfigSubscriptionVariables = {
  filter?: ModelSubscriptionAppConfigFilterInput | null,
};

export type OnCreateAppConfigSubscription = {
  onCreateAppConfig?:  {
    __typename: "AppConfig",
    id: string,
    appName?: AppNames | null,
    enableFreezeCard?:  {
      __typename: "FeatureFlagType",
      isEnabled?: boolean | null,
      description?: string | null,
    } | null,
    enableShowPin?: boolean | null,
    minimumTmcTopUpAmount?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateAppConfigSubscriptionVariables = {
  filter?: ModelSubscriptionAppConfigFilterInput | null,
};

export type OnUpdateAppConfigSubscription = {
  onUpdateAppConfig?:  {
    __typename: "AppConfig",
    id: string,
    appName?: AppNames | null,
    enableFreezeCard?:  {
      __typename: "FeatureFlagType",
      isEnabled?: boolean | null,
      description?: string | null,
    } | null,
    enableShowPin?: boolean | null,
    minimumTmcTopUpAmount?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteAppConfigSubscriptionVariables = {
  filter?: ModelSubscriptionAppConfigFilterInput | null,
};

export type OnDeleteAppConfigSubscription = {
  onDeleteAppConfig?:  {
    __typename: "AppConfig",
    id: string,
    appName?: AppNames | null,
    enableFreezeCard?:  {
      __typename: "FeatureFlagType",
      isEnabled?: boolean | null,
      description?: string | null,
    } | null,
    enableShowPin?: boolean | null,
    minimumTmcTopUpAmount?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateFeatureFlagSubscriptionVariables = {
  filter?: ModelSubscriptionFeatureFlagFilterInput | null,
};

export type OnCreateFeatureFlagSubscription = {
  onCreateFeatureFlag?:  {
    __typename: "FeatureFlag",
    id: string,
    name?: string | null,
    description?: string | null,
    enabled?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateFeatureFlagSubscriptionVariables = {
  filter?: ModelSubscriptionFeatureFlagFilterInput | null,
};

export type OnUpdateFeatureFlagSubscription = {
  onUpdateFeatureFlag?:  {
    __typename: "FeatureFlag",
    id: string,
    name?: string | null,
    description?: string | null,
    enabled?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteFeatureFlagSubscriptionVariables = {
  filter?: ModelSubscriptionFeatureFlagFilterInput | null,
};

export type OnDeleteFeatureFlagSubscription = {
  onDeleteFeatureFlag?:  {
    __typename: "FeatureFlag",
    id: string,
    name?: string | null,
    description?: string | null,
    enabled?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateErrorMessagesSubscriptionVariables = {
  filter?: ModelSubscriptionErrorMessagesFilterInput | null,
};

export type OnCreateErrorMessagesSubscription = {
  onCreateErrorMessages?:  {
    __typename: "ErrorMessages",
    id: string,
    ErrorKey?: ErrorKeys | null,
    ErrorNumber?: number | null,
    ErrorDescription?: string | null,
    InAppErrorMessage?:  {
      __typename: "InAppErrorMessageType",
      title?: string | null,
      body?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateErrorMessagesSubscriptionVariables = {
  filter?: ModelSubscriptionErrorMessagesFilterInput | null,
};

export type OnUpdateErrorMessagesSubscription = {
  onUpdateErrorMessages?:  {
    __typename: "ErrorMessages",
    id: string,
    ErrorKey?: ErrorKeys | null,
    ErrorNumber?: number | null,
    ErrorDescription?: string | null,
    InAppErrorMessage?:  {
      __typename: "InAppErrorMessageType",
      title?: string | null,
      body?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteErrorMessagesSubscriptionVariables = {
  filter?: ModelSubscriptionErrorMessagesFilterInput | null,
};

export type OnDeleteErrorMessagesSubscription = {
  onDeleteErrorMessages?:  {
    __typename: "ErrorMessages",
    id: string,
    ErrorKey?: ErrorKeys | null,
    ErrorNumber?: number | null,
    ErrorDescription?: string | null,
    InAppErrorMessage?:  {
      __typename: "InAppErrorMessageType",
      title?: string | null,
      body?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};
